export default {
    productLineList: '', //产品线列表
    plineScrollTop: '', //产品线列表滚动位置
    plineProductScrollTop: '', //产品线商品列表滚动位置
}


// WEBPACK FOOTER //
// ./src/store/product-line/state.js